<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div id="azureReportingDashboard" class="subBlockContainer">
    <div class="subBlockContent">
      <child-header [title]="title" (closeEvent)="close()" [showDownload]="isHistorical || isEstimatedUsage || isCurrentUsage || isArchive" titleDownload="Download Excel" (downloadEvent)="downloadEvent()" ></child-header>
      <div class="inner-subBlock-wrapper">
        <!-- <div class="page-title-wrapper">
          <div class="title blade-title">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div> -->

        <div id="basic-info-wrapper">
          <div class="row filter-wrapper">
            <div class="col col-dropdown max-width-x235">
                <!-- Select Usage Type:
                <div class="searchInputGroup">
                  <div class="dropdown">
                      <button class="btn btn-dropdown dropdown-toggle" type="button" id="btnType" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{ currentType }}
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnStatus">
                        <a class="dropdown-item drp-status" (click)="selectType('CURRENT USAGE');">CURRENT USAGE</a>
                        <a class="dropdown-item drp-status" (click)="selectType('HISTORICAL USAGE');">HISTORICAL USAGE</a>
                      </div>
                    </div>
                </div> -->
                <ng-select class="customDropdwon" [items]="types" bindValue="id" bindLabel="value"
                     placeholder="Select Usage Type" [clearable]="false" [(ngModel)]="selectedType" (change)="selectType()"></ng-select>
            </div>
            <div class="row filter-wrapper margin-l-x15 padding-b-x10">
              <div class="col searchInput-position">
                  <div class="searchInputGroup">
                    <div class="searchIcon">
                      <img src="../../images/new_ui/filter.png">
                    </div>
                    <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                      onblur="this.placeholder='Filter'" [(ngModel)]="searchField">
                  </div>
              </div>
              <ng-container *ngIf="isArchive == false; else archiveFrom" style="display: none;">
                <div class="col col-large" *ngIf="isHistorical || isEstimatedUsage">
                  Dated From:
                  <div class="searchInputGroup">
                    <div class="searchIcon" (click)="dateFrom.toggle()">
                      <img src="../../images/new_ui/date.png">
                    </div>
                    <input id="dateFrom" class="searchInput date-picker" type="text" [(ngModel)]="fromDate" [minDate] = "minDateFilter" placeholder="Date"
                      mame="datePicker" ngbDatepicker #dateFrom="ngbDatepicker" (click)="dateFrom.toggle()">
                  </div>
                </div>              
              </ng-container>
              <ng-template #archiveFrom>
                <div class="col col-large" *ngIf="isHistorical || isEstimatedUsage">
                  Dated From:
                  <div class="searchInputGroup">
                    <div class="searchIcon" (click)="dateFromArchive.toggle()">
                      <img src="../../images/new_ui/date.png">
                    </div>
                    <input id="dateFromArchive" class="searchInput date-picker" type="text" [(ngModel)]="fromDateArchive" [maxDate] = "maxDateFilter" placeholder="Date"
                      mame="datePicker" ngbDatepicker #dateFromArchive="ngbDatepicker" (click)="dateFromArchive.toggle()">
                  </div>
                </div>
              </ng-template>

              <ng-container *ngIf="isArchive == false;else archiveTo" style="display: none;">
                <div class="col col-large date-margin" *ngIf="isHistorical || isEstimatedUsage">
                  To:
                  <div class="searchInputGroup">
                    <div class="searchIcon" (click)="dateTo.toggle()">
                      <img src="../../images/new_ui/date.png">
                    </div>
                    <input id="dateTo" class="searchInput date-picker" type="text" [(ngModel)]="toDate" [minDate] = "minDateFilter" placeholder="Date"
                      mame="datePicker" ngbDatepicker #dateTo="ngbDatepicker" (click)="dateTo.toggle()">
              
                  </div>
                </div>
              </ng-container>
              <ng-template #archiveTo>
                <div class="col col-large date-margin" *ngIf="isHistorical || isEstimatedUsage">
                  To:
                  <div class="searchInputGroup">
                    <div class="searchIcon" (click)="dateToArchive.toggle()">
                      <img src="../../images/new_ui/date.png">
                    </div>
                    <input id="dateToArchive" class="searchInput date-picker" type="text" [(ngModel)]="toDateArchive" [maxDate] = "maxDateFilter" placeholder="Date"
                      mame="datePicker" ngbDatepicker #dateToArchive="ngbDatepicker" (click)="dateToArchive.toggle()">      
                  </div>
                </div>
              </ng-template>
                <ng-container *ngIf = "isArchive == false; else archiveApply">
                <div class="col col-small button-position" *ngIf="isHistorical || isEstimatedUsage">
                  <button id="btnFilter" class="button button-red button-mid" (click)="filterReports();">Apply</button>
                </div>
              </ng-container>
              <ng-template #archiveApply>
                <div class="col col-small button-position" *ngIf="isHistorical || isEstimatedUsage">
                  <button id="btnFilter" class="button button-red button-mid" (click)="filterReportsArchive();">Apply</button>
                </div>
              </ng-template>
          
              <!-- <div class="col col-small" *ngIf="isHistorical || isEstimatedUsage">
                <div id="btnDownload" class="basic-icon download-icon download-icon-position" placement="top" ngbTooltip="Download Excel" (click)="downloadReports()"></div>
              </div>
              <div class="col col-small" *ngIf="isCurrentUsage">
                <div id="btnDownload" class="basic-icon download-icon download-icon-position" placement="top" ngbTooltip="Download Excel" (click)="download_UnbilledReports()"></div>
              </div> -->
            </div>

          </div>
        </div>

        <div class="row">
          <div class="column" style="margin-left:15px;">
            Show Archive &nbsp;
            <mat-slide-toggle (change)="showArchive($event)" [checked]="isArchive">
            </mat-slide-toggle>
          </div>
        </div>

       <!--  <ng-container>        
          <div class="row">
            <div class="column" style="margin-left:15px;">
              Show Archive &nbsp;
              <mat-slide-toggle (change)="showArchive($event)" [checked]="isArchive">
                <ng-container *ngIf= "isArchive">
                  <br>
                  <br>
                  <div class="row margin-l-x15 padding-b-x10">                    
                    <div class="col col-large" style="margin-left:310px;font-size: 12px;" *ngIf="isHistorical || isEstimatedUsage">
                      Dated From:
                      <div class="searchInputGroup">
                        <div class="searchIcon" (click)="dateFromArchive.toggle()">
                          <img src="../../images/new_ui/date.png">
                        </div>
                        <input id="dateFromArchive" class="searchInput date-picker" type="text" [(ngModel)]="fromDateArchive" placeholder="Date"
                          mame="datePicker" ngbDatepicker #dateFromArchive="ngbDatepicker" (click)="dateFromArchive.toggle()">
                      </div>
                    </div>
                    <div class="col col-large date-margin" style = "margin-left: -50px;font-size: 12px;" *ngIf="isHistorical || isEstimatedUsage">
                      To:
                      <div class="searchInputGroup">
                        <div class="searchIcon" (click)="dateToArchive.toggle()">
                          <img src="../../images/new_ui/date.png">
                        </div>
                        <input id="dateToArchive" class="searchInput date-picker" type="text" [(ngModel)]="toDateArchive" placeholder="Date"
                          mame="datePicker" ngbDatepicker #dateToArchive="ngbDatepicker" (click)="dateToArchive.toggle()">      
                      </div>
                    </div>
                    <div class="col-small button-position" *ngIf="isHistorical || isEstimatedUsage">
                      <button id="btnFilter" class="button button-red button-mid" (click)="filterReports();">Apply</button>
                    </div>
                  </div>
                </ng-container>
              </mat-slide-toggle>
            </div>            
          </div>        
        </ng-container> -->
       

        <div class="inner-subBlock-wrapper" [hidden]="true">
            <div class="page-subtitle-wrapper">{{currentType}} REPORT</div>
            <div class="row report-title-position">
                <div class="col infoSection shadow-wrapper">
                    <div class="chartSection">
                        <canvas #chartUsageByTenants id="chartUsageByTenants" width="308" height="286"></canvas>
                        
                    </div>
                </div>
                <div class="col infoSection shadow-wrapper">
                    <div class="chartSection">
                        <canvas #chartUsageByCategory id="chartUsageByCategory" width="308" height="286"></canvas>
                    </div>
                </div>

            </div>
        </div>

        <div class="inner-subBlock-wrapper" *ngIf="loadingFinished">
          <div class="page-subtitle-wrapper" *ngIf="isCurrentUsage">CURRENT USAGE - UNBILLED FROM {{ firstDayOfCurrentMonth }}</div>
          <div class="page-subtitle-wrapper" *ngIf="isUnbilledLastMonth">UNBILLED USAGE FOR {{ lastMonth }}</div>
         <!--  <div class="page-subtitle-wrapper" *ngIf="isHistorical">USAGE REPORT FROM {{ strDateFrom }} TO {{ strDateTo }}</div>
          <div class="page-subtitle-wrapper" *ngIf="isEstimatedUsage">ESTIMATED USAGE REPORT FROM {{ strDateFrom }} TO {{ strDateTo }}</div> -->
          <div class="page-subtitle-wrapper" *ngIf="isHistorical && isArchive == false;else archiveReport">USAGE REPORT FROM {{ strDateFrom }} TO {{ strDateTo }}</div>
          <ng-template #archiveReport>
            <div class="page-subtitle-wrapper" *ngIf="isHistorical">ARCHIVE USAGE REPORT FROM {{ strDateFromArchive }} TO {{ strDateToArchive }}</div>
          </ng-template>
          <div class="page-subtitle-wrapper" *ngIf="isEstimatedUsage  && isArchive == false;else archiveEstimatedReport">ESTIMATED USAGE REPORT FROM {{ strDateFrom }} TO {{ strDateTo }}</div>
          <ng-template #archiveEstimatedReport>
            <div class="page-subtitle-wrapper" *ngIf="isEstimatedUsage">ESTIMATED ARCHIVE USAGE REPORT FROM {{ strDateFromArchive }} TO {{ strDateToArchive }}</div>
          </ng-template>

          <div class="shared-outer-wrapper table-header-allign" *ngIf="loadContent && tenantList?.length">
            <table matSort (matSortChange)="sortData($event)">
              <thead>
                <tr class="row order-title-wrapper">
                  <th class="col align-center" style="min-width: 32%;" mat-sort-header="tenantName">TENANT NAME</th>
                  <!-- <th class="col align-center" mat-sort-header="nextBillingDate" style="min-width: 18%;" *ngIf="!isHistorical">NEXT BILLING DATE</th> -->
                  <th class="col align-center" mat-sort-header="subscriptionID" *ngIf="isHistorical">SUBSCRIPTION ID</th>
                  <th class="col align-center" mat-sort-header="subscriptionName">SUB NAME</th>
                  <!-- <th class="col" mat-sort-header="noOfDaysUntilBillingDate" *ngIf="!isHistorical">DAYS TO NEXT BILLING</th> -->
                  <th class="col align-center" mat-sort-header="currentUsageTotal" *ngIf="!isEstimatedUsage" style="min-width: 18%;"><span>{{isHistorical ? 'TOTAL AMOUNT' : 'CURRENT AMOUNT'}}</span></th>
                  <th class="col align-right" mat-sort-header="estimatedUsageTotal" *ngIf="!isHistorical">ESTIMATED TOTAL</th>
                  <th class="col align-center" style="max-width: 10%;">ACTION</th>
                  <!-- <th class="col align-center" style="max-width: 5%" *ngIf="isHistorical"></th> -->
                </tr>
              </thead>
            </table>
            <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
              *ngIf="showPager"></pagination-controls> -->
          </div>
          <div class="shared-outer-wrapper child-body" *ngIf="loadContent && tenantList?.length">
            <table matSort (matSortChange)="sortData($event)">
              <thead hidden="true">
                <tr class="row order-title-wrapper">
                  <th class="col align-center" style="min-width: 32%;" mat-sort-header="tenantName">TENANT NAME</th>
                  <!-- <th class="col align-center" mat-sort-header="nextBillingDate" style="min-width: 18%;" *ngIf="!isHistorical">NEXT BILLING DATE</th> -->
                  <th class="col align-center" mat-sort-header="subscriptionID" *ngIf="isHistorical">SUBSCRIPTION ID</th>
                  <th class="col align-center" mat-sort-header="subscriptionName">SUB NAME</th>
                  <!-- <th class="col" mat-sort-header="noOfDaysUntilBillingDate" *ngIf="!isHistorical">DAYS TO NEXT BILLING</th> -->
                  <th class="col align-center" mat-sort-header="currentUsageTotal" *ngIf="!isEstimatedUsage" style="min-width: 18%;"><span>{{isHistorical ? 'TOTAL AMOUNT' : 'CURRENT AMOUNT'}}</span></th>
                  <th class="col align-right" mat-sort-header="estimatedUsageTotal" *ngIf="!isHistorical">ESTIMATED TOTAL</th>
                  <th class="col align-center" style="max-width: 10%;">ACTION</th>
                  <!-- <th class="col align-center" style="max-width: 5%" *ngIf="isHistorical"></th> -->
                </tr>
              </thead>
              <tbody class="scrollable-table-body">
                <ng-container>
                  <ng-container *ngFor="let tenant of sortedData | TableFilterMultiple:['tenantName', 'nextBillingDate', 'subscriptionName'] : searchField">
                    <tr class="row order-content-wrapper">
                      <td class="col-md align-left" style="min-width: 32%;">{{tenant?.tenantName}}</td>
                      <!-- <td class="col-md align-left" style="min-width: 18%;" *ngIf="!isHistorical">{{tenant?.nextBillingDate}}</td> -->
                      <td class="col-md align-left" *ngIf="isHistorical">{{tenant?.subscriptionID}}</td>
                      <td class="col-md align-left">{{tenant?.subscriptionName}}</td>
                      <!-- <td class="col-md" *ngIf="!isHistorical">{{tenant?.noOfDaysUntilBillingDate}}</td> -->
                      <td class="col-md align-left text-right pr-60" [ngClass]="{'historical-align': isHistorical}"
                      *ngIf="!isEstimatedUsage">{{tenant?.currentUsageTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="col-md align-left text-right pr-60"  [ngClass]="{'estimate-align': isEstimatedUsage}" *ngIf="!isHistorical">{{tenant?.estimatedUsageTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="col-md align-center" style="max-width: 10%;" *ngIf="isCurrentUsage || isUnbilledLastMonth || isCurrentUsageMicrosoft">                                               
                          <div id="downloadBtn{{tenant?.subscriptionID}}" class="basic-icon download-icon" placement="top" ngbTooltip="Download Excel" (click)="download_UnbilledReports(tenant?.tenantID, tenant?.subscriptionID)"></div>                                           
                      </td>
                      <td class="col-md align-center" style="max-width: 10%" *ngIf="isHistorical">
                        <div *ngIf="isArchive == false; else archiveIsHistorical">
                          <div id="downloadBtn{{tenant?.subscriptionID}}" class="basic-icon download-icon" placement="top" ngbTooltip="Download Excel" (click)="exportHistoricalUsageReport(tenant?.subscriptionID)"></div>
                        </div>
                        <ng-template #archiveIsHistorical>
                          <div id="downloadBtn{{tenant?.subscriptionID}}" class="basic-icon download-icon" placement="top" ngbTooltip="Download Excel" (click)="exportHistoricalUsageReportArchive(tenant?.subscriptionID)"></div>
                        </ng-template>
                      </td>
                      <td class="col-md align-center" style="max-width: 10%" *ngIf="isEstimatedUsage">
                        <div id="downloadBtn{{tenant?.subscriptionID}}" class="basic-icon download-icon" placement="top" ngbTooltip="Download Excel" (click)="exportEstimatedUsageReport(tenant?.tenantID, tenant?.subscriptionID)"></div>
                    </td>
                   
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
            <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
              *ngIf="showPager"></pagination-controls> -->
          </div>
        </div>

        <div class="inner-subBlock-wrapper" *ngIf="loadContent && loadingFinished && !tenantList?.length">
            <div class="noData-wrapper">
              <div>
                  <img src="../../images/new_ui/no-subscription.png">
                </div>
              <label class="noData-label">
                  WE COULDN'T FIND ANY DATA<br/>
            </label>
            <br/>

            </div>
        </div>

      </div>

      <loading-screen *ngIf="!loadContent" [showBlurTable]="true"  (currentLoadingStatus)="onLoading($event)"></loading-screen>
    </div>
  </div>


  <router-outlet></router-outlet>

